import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Paper } from '@mui/material';
import { fetchTimeslotData } from '../services/timeslot';
import TicketSalesAggregationChart from './UI-components/Timeslot/TicketSalesAggregationChart';


const Timeslot = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [timeslotData, setTimeslotData] = useState([]);
  const companyName = useSelector((state) => state.company.company);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const timeslotDataResponse = await Promise.all([
          dispatch(fetchTimeslotData())
        ]);

        const timeslotPayload = timeslotDataResponse[0].payload || [];
        setTimeslotData(timeslotPayload);

      } catch (error) {
        console.error('Error:', error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [dispatch, companyName])

  const pivotData = timeslotData.reduce((acc, row) => {
    const eventId = row.event_id;
    const eventDate = row.event_date;
    const timeSlot = row.time_slot;
  
    if (!acc[eventId]) acc[eventId] = {};
    if (!acc[eventId][eventDate]) acc[eventId][eventDate] = {};
    if (!acc[eventId][eventDate][timeSlot]) acc[eventId][eventDate][timeSlot] = 0;
  
    acc[eventId][eventDate][timeSlot] += row.daily_ticket_count || 0;
  
    return acc;
  }, {});  

  const pivotRows = [];

  Object.entries(pivotData).forEach(([eventId, dates]) => {
    Object.entries(dates).forEach(([eventDate, slots]) => {
      Object.entries(slots).forEach(([timeSlot, count], i) => {
        pivotRows.push({
          id: `${eventId}-${eventDate}-${timeSlot}-${i}`,
          event_id: eventId,
          event_date: eventDate,
          time_slot: timeSlot,
          ticket_count: count
        });
      });
    });
  });
  // sort pivot rows by event_date (oldest to newest)
  pivotRows.sort((a, b) => new Date(a.event_date) - new Date(b.event_date));

  return (
    <Paper style={{ padding: '10px' }}>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <div style={{ height: '70vh', width: 'auto', overflowX: 'false', position: 'relative', margin: 'auto' }}>
            <DataGrid 
              rows={timeslotData}

              columns={[
                { field: 'sale_date', headerName: 'Sale Date', width: 150 },
                { field: 'event_id', headerName: 'Event ID', width: 250 },
                { field: 'event_date', headerName: 'Event Date', width: 150 },
                { field: 'time_slot', headerName: 'Time Slot', width: 150 },
                { field: 'daily_ticket_count', headerName: 'Ticket Count', width: 150 },
                { field: 'daily_orders', headerName: 'Order Count', width: 150 },
              ]}
              slots={{ toolbar: GridToolbar }}
              style={{ width: '100%', position: 'absolute' }}
              showCellVerticalBorder
              showColumnVerticalBorder
            />
          </div>
          <h3 style={{ marginTop: '2rem' }}>📊 Pivot Table: Total Tickets Sold by Time Slot</h3>
          <div style={{ height: '60vh', width: 'auto', overflowX: 'false', position: 'relative', margin: 'auto' }}>
            <DataGrid
              rows={pivotRows}
              columns={[
                { field: 'event_id', headerName: 'Event ID', width: 250 },
                { field: 'event_date', headerName: 'Event Date', width: 150 },
                { field: 'time_slot', headerName: 'Time Slot', width: 150 },
                { field: 'ticket_count', headerName: 'Total Tickets Sold', width: 180 },
              ]}
              slots={{ toolbar: GridToolbar }}
              style={{ width: '100%', position: 'absolute' }}
              showCellVerticalBorder
              showColumnVerticalBorder
              unstable_rowSpanning
            />
          </div>
          <TicketSalesAggregationChart timeslotData={timeslotData} />
        </>
      )}
    </Paper>
  )
}

export default Timeslot;
